"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useState } from "react";
import DialogSuccess from "./DialogSuccess";
import DialogDelete from "./DialogDelete";
import { formatDate } from "../../utils";
import { removeSubAdmin, setAsSubAdmin, addNewSubAdminByEmail } from "../../firebase/subAdmins";
import { subAdminPrivileges } from "../../utils/data";
import { toast } from "react-toastify";

export default function DialogManageSubAdmin({
    open,
    onClose,
    user
}) {
    const [showSuccessDialog, setShowSuccessDialog] = useState(false)
    const [showDeactiveConfirmModel, setShowDeactiveConfirmModel] = useState(false)
    const [email, setEmail] = useState();
    const [privileges, setPrivileges] = useState([]);  

    useEffect(() => {
        if (user) {
            setEmail(user.email)
            setPrivileges(user.privileges || [])
        }
        else {
            setEmail('')
            setPrivileges([])
        }
    }, [user])
    const onClickDeactivate = async () => {
        try{
            await removeSubAdmin(user.id)
            setShowDeactiveConfirmModel(false)
            setShowSuccessDialog(true)
        }
        catch(e){
            console.error("Error removing sub-admin: ", e)
            toast.error(e.message || "Failed to remove sub-admin")
        }
    }

    const handleChange = async () => {
        try{
            if(!email){
                toast.error("Email is required")
                return;
            }
            if(user)
                await setAsSubAdmin(user.id, privileges)
            else                
                await addNewSubAdminByEmail(email, privileges)
            setShowDeactiveConfirmModel(false)
            setShowSuccessDialog(true)
        }
        catch(e){
            console.error("Error setting sub-admin: ", e)
            toast.error(e.message || "Failed to set sub-admin")
        }
        onClose();
    }

    return (
        <>
            <DialogSuccess
                message="Sub admin successfully removed from this account"
                open={showSuccessDialog}
                onClose={() => {
                    setShowSuccessDialog(false)
                    onClose();
                }}
                buttonText="Close"
                buttonLink="#"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <DialogDelete
                message="Are you sure you want to remove sub admin from this account?"
                open={showDeactiveConfirmModel}
                onClose={() => setShowDeactiveConfirmModel(false)}
                buttonText="Deactive Account"
                onButtonClick={onClickDeactivate}
                title="Deactive Account?"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            

            <Dialog open={open} onClose={onClose} className="relative z-[10000]">
                <DialogBackdrop
                    transition
                    className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
                />

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                        <DialogPanel
                            transition
                            className="relative transform overflow-hidden w-[550px] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                        >
                            <div className="w-full flex flex-col relative p-6 min-h-[484px]">
                                <div className="flex justify-between">
                                    <div className="flex">
                                        <span className="text-primary text-[28px]">SubAdmin Privilege</span>
                                    </div>

                                    <button
                                        onClick={onClose}
                                        className="top-2 right-2 cursor-pointer z-[1]"
                                    >
                                        <img
                                            src="/assets/icons/icon-close.svg"
                                            alt="Close"
                                            className="invert cursor-pointer"
                                        />
                                    </button>
                                </div>

                                <div className="h-full flex flex-col justify-center">
                                    {
                                        user &&
                                        <div className="flex text-white items-center">
                                            <img src="/assets/avatars/default.png" className="rounded-[50%] w-[75px] mr-4" />
                                            <div className="text-base">{user.displayName}</div>
                                        </div>
                                    }
                                    <div>
                                        <div className="text-sm text-[#6E6E6E] mt-6">Email</div>
                                        <input type="text" value={email} disabled={!!user} className="w-full bg-[#2f2f2f] rounded-[8px] py-3 px-4 mt-1 text-sm text-white" 
                                                onChange={(e)=>setEmail(e.target.value)}
                                        />
                                    </div>
                                    <div>
                                        <div className="text-sm text-[#6E6E6E] mt-4">Privileges</div>
                                        <select multiple value={privileges} onChange={(e) => {
                                            const options = e.target.options;
                                            const selectedPrivileges = [];
                                            for (let i = 0; i < options.length; i++) {
                                                if (options[i].selected) {
                                                    selectedPrivileges.push(options[i].value);
                                                }
                                            }
                                            setPrivileges(selectedPrivileges);
                                        }} className="w-full bg-[#2f2f2f] rounded-[8px] py-3 px-4 mt-1 text-sm text-white">
                                            {
                                                subAdminPrivileges.map(priv => (
                                                    <option value={priv.value} key={priv.value}>{priv.label}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="flex mt-14 gap-3">
                                        <button className="text-white bg-primary py-3 text-xs rounded-[10px] w-full" onClick={() => handleChange(true)}>
                                            Change
                                        </button>
                                        {
                                            user &&
                                            <button className="bg-[#E5E5E5] text-[#6E6E6E] py-3 text-xs rounded-[10px] w-full" onClick={() => setShowDeactiveConfirmModel(true)}>
                                                Remove Sub Admin
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
